import { configAxios } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const confirmEnterprise = async (id, type) => {
    const api = configAxios();
    const { data } = await api.put(`${ENDPOINTS.CONFIRM_ENTERPRISE}${id}/${type}/`);
    return data;
};
